// // // // // // import React from 'react';
// // // // // // import { Button } from './ui/button';
// // // // // // import { ArrowRight } from 'lucide-react';
// // // // // // import { hero } from '../mockData';

// // // // // // const Hero = () => {
// // // // // //   return (
// // // // // //     <section className="relative pt-32 pb-96 px-6 overflow-visible bg-white">
// // // // // //       <div className="max-w-7xl mx-auto">
// // // // // //         {/* Badge */}
// // // // // //         <div className="flex justify-center mb-8 animate-in fade-in slide-in-from-top duration-700">
// // // // // //           <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-500 to-pink-600 text-white px-5 py-2.5 rounded-full text-sm font-medium shadow-lg">
// // // // // //             <span className="bg-white/20 px-3 py-1 rounded-full text-xs font-semibold">{hero.badge}</span>
// // // // // //             <span>{hero.badgeText}</span>
// // // // // //           </div>
// // // // // //         </div>

// // // // // //         {/* Main Title */}
// // // // // //         <div className="text-center max-w-5xl mx-auto mb-12 animate-in fade-in slide-in-from-bottom duration-700">
// // // // // //           <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-8 leading-tight tracking-tight">
// // // // // //             {hero.title}
// // // // // //           </h1>
// // // // // //           <p className="text-xl md:text-2xl text-gray-600 mb-10 max-w-2xl mx-auto">
// // // // // //             {hero.subtitle}
// // // // // //           </p>
// // // // // //           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 rounded-xl px-10 py-7 text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
// // // // // //             {hero.cta}
// // // // // //             <ArrowRight className="w-5 h-5 ml-2" />
// // // // // //           </Button>
// // // // // //         </div>

// // // // // //         {/* Phone Mockups with Screenshots - 5 Phones Layout */}
// // // // // //         <div className="relative mt-24 h-[700px] max-w-7xl mx-auto">
// // // // // //           {/* Left Phone 1 - Far Left */}
// // // // // //           <div className="absolute left-0 top-48 w-56 transform -rotate-12 hover:rotate-0 hover:scale-105 transition-all duration-500 z-10">
// // // // // //             <div className="relative">
// // // // // //               <img src={hero.images[2]} alt="Phone" className="w-full drop-shadow-2xl" />
// // // // // //               <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[2.5rem]">
// // // // // //                 <img src={hero.images[1]} alt="Screenshot" className="w-full h-full object-cover object-top" />
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* Left Phone 2 - Near Left */}
// // // // // //           <div className="absolute left-[18%] top-20 w-64 transform -rotate-6 hover:rotate-0 hover:scale-105 transition-all duration-500 z-20">
// // // // // //             <div className="relative">
// // // // // //               <img src={hero.images[2]} alt="Phone" className="w-full drop-shadow-2xl" />
// // // // // //               <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[2.5rem]">
// // // // // //                 <img src={hero.images[3]} alt="Screenshot" className="w-full h-full object-cover object-top" />
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* Center Phone - Main Focus (Largest) */}
// // // // // //           <div className="absolute left-1/2 transform -translate-x-1/2 top-0 w-80 z-30 hover:scale-105 transition-all duration-500">
// // // // // //             <div className="relative">
// // // // // //               <img src={hero.images[2]} alt="Phone" className="w-full drop-shadow-2xl" />
// // // // // //               <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[2.5rem]">
// // // // // //                 <img src={hero.images[4]} alt="Screenshot" className="w-full h-full object-cover object-top" />
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* Right Phone 1 - Near Right */}
// // // // // //           <div className="absolute right-[18%] top-20 w-64 transform rotate-6 hover:rotate-0 hover:scale-105 transition-all duration-500 z-20">
// // // // // //             <div className="relative">
// // // // // //               <img src={hero.images[2]} alt="Phone" className="w-full drop-shadow-2xl" />
// // // // // //               <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[2.5rem]">
// // // // // //                 <img src={hero.images[1]} alt="Screenshot" className="w-full h-full object-cover object-top" />
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* Right Phone 2 - Far Right */}
// // // // // //           <div className="absolute right-0 top-48 w-56 transform rotate-12 hover:rotate-0 hover:scale-105 transition-all duration-500 z-10">
// // // // // //             <div className="relative">
// // // // // //               <img src={hero.images[2]} alt="Phone" className="w-full drop-shadow-2xl" />
// // // // // //               <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[2.5rem]">
// // // // // //                 <img src={hero.images[3]} alt="Screenshot" className="w-full h-full object-cover object-top" />
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </div>
// // // // // //     </section>
// // // // // //   );
// // // // // // };

// // // // // // export default Hero;

// // // // // import React, { useState, useEffect } from 'react';
// // // // // import { Button } from './ui/button';
// // // // // import { ArrowRight } from 'lucide-react';
// // // // // import axios from 'axios';
// // // // // import { Swiper, SwiperSlide } from 'swiper/react';
// // // // // import { EffectCoverflow, Pagination, Autoplay, Navigation } from 'swiper/modules';
// // // // // import 'swiper/css';
// // // // // import 'swiper/css/effect-coverflow';
// // // // // import 'swiper/css/pagination';
// // // // // import 'swiper/css/navigation';

// // // // // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
// // // // // const PHONE_MOCKUP = "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png";

// // // // // const Hero = () => {
// // // // //   const [heroData, setHeroData] = useState(null);

// // // // //   useEffect(() => {
// // // // //     fetchHeroData();
// // // // //   }, []);

// // // // //   const fetchHeroData = async () => {
// // // // //     try {
// // // // //       const response = await axios.get(`${BACKEND_URL}/api/public/hero`);
// // // // //       setHeroData(response.data);
// // // // //     } catch (error) {
// // // // //       console.error('Failed to fetch hero data:', error);
// // // // //       // Fallback to mock data with mixed content
// // // // //       setHeroData({
// // // // //         badge: "New",
// // // // //         badge_text: "Welcome to TokoSprint",
// // // // //         title: "Build & grow your online store effortlessly",
// // // // //         subtitle: "Everything you need to launch your store in minutes.",
// // // // //         cta_text: "Get Started",
// // // // //         images: [
// // // // //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif" },
// // // // //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b10f6fc0682fbb04ccd8_Screenshot%202025-11-03%20222734.png" },
// // // // //           { type: "phone", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png", screenshot: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b0f2df576aa7a8d2d64e_Screenshot%202025-11-04%20101504.png" },
// // // // //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b1513050004f070d6d76_Screenshot%202025-11-04%20145444.png" },
// // // // //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif" }
// // // // //         ]
// // // // //       });
// // // // //     }
// // // // //   };

// // // // //   if (!heroData) {
// // // // //     return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
// // // // //   }

// // // // //   const showControls = heroData.images.length > 5;

// // // // //   return (
// // // // //     <section className="relative pt-32 pb-96 px-6 overflow-visible bg-white">
// // // // //       <div className="max-w-7xl mx-auto">
// // // // //         {/* Badge */}
// // // // //         <div className="flex justify-center mb-8 animate-in fade-in slide-in-from-top duration-700">
// // // // //           <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-500 to-pink-600 text-white px-5 py-2.5 rounded-full text-sm font-medium shadow-lg">
// // // // //             <span className="bg-white/20 px-3 py-1 rounded-full text-xs font-semibold">{heroData.badge}</span>
// // // // //             <span>{heroData.badge_text}</span>
// // // // //           </div>
// // // // //         </div>

// // // // //         {/* Main Title */}
// // // // //         <div className="text-center max-w-5xl mx-auto mb-12 animate-in fade-in slide-in-from-bottom duration-700">
// // // // //           <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-8 leading-tight tracking-tight">
// // // // //             {heroData.title}
// // // // //           </h1>
// // // // //           <p className="text-xl md:text-2xl text-gray-600 mb-10 max-w-2xl mx-auto">
// // // // //             {heroData.subtitle}
// // // // //           </p>
// // // // //           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 rounded-xl px-10 py-7 text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
// // // // //             {heroData.cta_text}
// // // // //             <ArrowRight className="w-5 h-5 ml-2" />
// // // // //           </Button>
// // // // //         </div>

// // // // //         {/* Swiper Carousel with Coverflow Effect */}
// // // // //         <div className="relative mt-24 w-full px-4">
// // // // //           <Swiper
// // // // //             effect={'coverflow'}
// // // // //             grabCursor={true}
// // // // //             centeredSlides={true}
// // // // //             loop={true}
// // // // //             slidesPerView={'auto'}
// // // // //             coverflowEffect={{
// // // // //               rotate: 0,
// // // // //               stretch: 35,
// // // // //               depth: 150,
// // // // //               modifier: 1.5,
// // // // //               slideShadows: false,
// // // // //             }}
// // // // //             autoplay={{
// // // // //               delay: 3500,
// // // // //               disableOnInteraction: false,
// // // // //             }}
// // // // //             pagination={{
// // // // //               clickable: true,
// // // // //               dynamicBullets: true,
// // // // //             }}
// // // // //             navigation={true}
// // // // //             modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
// // // // //             className="hero-swiper"
// // // // //             breakpoints={{
// // // // //               320: {
// // // // //                 slidesPerView: 1,
// // // // //                 spaceBetween: 10,
// // // // //                 coverflowEffect: {
// // // // //                   depth: 100,
// // // // //                   modifier: 1,
// // // // //                 },
// // // // //               },
// // // // //               768: {
// // // // //                 slidesPerView: 2,
// // // // //                 spaceBetween: 20,
// // // // //                 coverflowEffect: {
// // // // //                   depth: 150,
// // // // //                   modifier: 1.2,
// // // // //                 },
// // // // //               },
// // // // //               1024: {
// // // // //                 slidesPerView: 3,
// // // // //                 spaceBetween: 30,
// // // // //                 coverflowEffect: {
// // // // //                   depth: 150,
// // // // //                   modifier: 1.5,
// // // // //                 },
// // // // //               },
// // // // //             }}
// // // // //           >
// // // // //             {heroData.images.map((item, index) => {
// // // // //               // Handle string format (old data) - convert to object
// // // // //               const imageData = typeof item === 'string' ? { type: 'screenshot', url: item } : item;

// // // // //               return (
// // // // //                 <SwiperSlide key={index} className="hero-slide">
// // // // //                   <div className="w-full flex items-center justify-center py-4">
// // // // //                     {imageData.type === 'phone' && imageData.screenshot ? (
// // // // //                       // Phone with screenshot inside
// // // // //                       <div className="relative w-full max-w-xs">
// // // // //                         {/* Screenshot layer - behind */}
// // // // //                         <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[2.5rem] z-0">
// // // // //                           <img src={imageData.screenshot} alt="Screenshot" className="w-full h-full object-cover object-top" />
// // // // //                         </div>
// // // // //                         {/* Phone mockup layer - front */}
// // // // //                         <img src={PHONE_MOCKUP} alt="Phone" className="relative w-full h-auto drop-shadow-2xl z-10" />
// // // // //                       </div>
// // // // //                     ) : imageData.type === 'person' ? (
// // // // //                       // Person image
// // // // //                       <img 
// // // // //                         src={imageData.url} 
// // // // //                         alt="Team" 
// // // // //                         className="w-full max-h-[600px] rounded-3xl shadow-2xl object-cover"
// // // // //                       />
// // // // //                     ) : (
// // // // //                       // Screenshot or other image
// // // // //                       <img 
// // // // //                         src={imageData.url} 
// // // // //                         alt="Screenshot" 
// // // // //                         className="w-full max-h-[600px] rounded-3xl shadow-2xl object-cover"
// // // // //                       />
// // // // //                     )}
// // // // //                   </div>
// // // // //                 </SwiperSlide>
// // // // //               );
// // // // //             })}
// // // // //           </Swiper>
// // // // //         </div>
// // // // //       </div>
// // // // //     </section>
// // // // //   );
// // // // // };

// // // // // export default Hero;


// // // // //INI FIXXX
// // // // import React, { useState, useEffect } from 'react';
// // // // import { Button } from './ui/button';
// // // // import { ArrowRight } from 'lucide-react';
// // // // import axios from 'axios';
// // // // import { Swiper, SwiperSlide } from 'swiper/react';
// // // // import { EffectCoverflow, Pagination, Autoplay, Navigation } from 'swiper/modules';
// // // // import 'swiper/css';
// // // // import 'swiper/css/effect-coverflow';
// // // // import 'swiper/css/pagination';
// // // // import 'swiper/css/navigation';

// // // // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000' || 'http://localhost:8000';
// // // // const PHONE_MOCKUP = "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png";

// // // // const Hero = () => {
// // // //   const [heroData, setHeroData] = useState(null);

// // // //   useEffect(() => {
// // // //     fetchHeroData();
// // // //   }, []);

// // // //   const fetchHeroData = async () => {
// // // //     try {
// // // //       const response = await axios.get(`${BACKEND_URL}/api/public/hero`);
// // // //       setHeroData(response.data);
// // // //     } catch (error) {
// // // //       console.error('Failed to fetch hero data:', error);
// // // //       // Fallback to mock data with mixed content
// // // //       setHeroData({
// // // //         badge: "New",
// // // //         badge_text: "Welcome to TokoSprint",
// // // //         title: "Build & grow your online store effortlessly",
// // // //         subtitle: "Everything you need to launch your store in minutes.",
// // // //         cta_text: "Get Started",
// // // //         images: [
// // // //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif" },
// // // //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b10f6fc0682fbb04ccd8_Screenshot%202025-11-03%20222734.png" },
// // // //           { type: "phone", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png", screenshot: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b0f2df576aa7a8d2d64e_Screenshot%202025-11-04%20101504.png" },
// // // //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b1513050004f070d6d76_Screenshot%202025-11-04%20145444.png" },
// // // //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif" }
// // // //         ]
// // // //       });
// // // //     }
// // // //   };

// // // //   if (!heroData) {
// // // //     return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
// // // //   }

// // // //   const showControls = heroData.images.length > 5;

// // // //   return (
// // // //     <section id="hero" className="relative pt-20 md:pt-32 pb-64 md:pb-20 px-4 md:px-6 overflow-visible bg-gradient-blue-strong bg-tech-dots">
// // // //       <div className="max-w-7xl mx-auto">
// // // //         {/* Badge */}
// // // //         <div className="flex justify-center mb-6 md:mb-8 animate-in fade-in slide-in-from-top duration-700">
// // // //           <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-brand-blue-500 to-brand-blue-600 text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-xs md:text-sm font-medium shadow-lg">
// // // //             <span className="bg-white/20 px-2 md:px-3 py-0.5 md:py-1 rounded-full text-xs font-semibold">{heroData.badge}</span>
// // // //             <span className="text-xs md:text-sm">{heroData.badge_text}</span>
// // // //           </div>
// // // //         </div>

// // // //         {/* Main Title */}
// // // //         <div className="text-center max-w-5xl mx-auto mb-8 md:mb-12 animate-in fade-in slide-in-from-bottom duration-700">
// // // //           <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-8 leading-tight tracking-tight px-2">
// // // //             {heroData.title}
// // // //           </h1>
// // // //           <p className="text-base md:text-xl lg:text-2xl text-gray-600 mb-6 md:mb-10 max-w-2xl mx-auto px-4">
// // // //             {heroData.subtitle}
// // // //           </p>
// // // //           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 rounded-xl px-6 md:px-10 py-5 md:py-7 text-base md:text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
// // // //             {heroData.cta_text}
// // // //             <ArrowRight className="w-4 h-4 md:w-5 md:h-5 ml-2" />
// // // //           </Button>
// // // //         </div>

// // // //         {/* Swiper Carousel with Coverflow Effect */}
// // // //         <div className="relative mt-12 md:mt-24 w-full">
// // // //           <Swiper
// // // //             effect={'coverflow'}
// // // //             grabCursor={true}
// // // //             centeredSlides={true}
// // // //             loop={false}
// // // //             slidesPerView={'1'}
// // // //             centerInsufficientSlides={true}
// // // //             coverflowEffect={{
// // // //               rotate: 0,
// // // //               stretch: 35,
// // // //               depth: 150,
// // // //               modifier: 1.5,
// // // //               slideShadows: false,
// // // //             }}
// // // //             autoplay={{
// // // //               delay: 2500,
// // // //               disableOnInteraction: false,
// // // //             }}
// // // //             pagination={{
// // // //               clickable: true,
// // // //               dynamicBullets: true,
// // // //             }}
// // // //             navigation={true}
// // // //             modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
// // // //             className="hero-swiper"
// // // //             breakpoints={{
// // // //               320: {
// // // //                 slidesPerView: 1,
// // // //                 spaceBetween: 10,
// // // //                 coverflowEffect: {
// // // //                   depth: 100,
// // // //                   modifier: 1,
// // // //                   stretch: 10,
// // // //                 },
// // // //               },
// // // //               640: {
// // // //                 slidesPerView: 1.5,
// // // //                 spaceBetween: 10,
// // // //                 coverflowEffect: {
// // // //                   depth: 120,
// // // //                   modifier: 1.1,
// // // //                   stretch: -10,
// // // //                 },
// // // //               },
// // // //               768: {
// // // //                 slidesPerView: 2,
// // // //                 spaceBetween: 20,
// // // //                 coverflowEffect: {
// // // //                   depth: 150,
// // // //                   modifier: 1.2,
// // // //                   stretch: 35,
// // // //                 },
// // // //               },
// // // //               1024: {
// // // //                 slidesPerView: 3,
// // // //                 spaceBetween: 30,
// // // //                 coverflowEffect: {
// // // //                   depth: 150,
// // // //                   modifier: 1.5,
// // // //                   stretch: 35,
// // // //                 },
// // // //               },
// // // //             }}
// // // //           >
// // // //             {heroData.images.map((item, index) => {
// // // //               // Handle string format (old data) - convert to object
// // // //               const imageData = typeof item === 'string' ? { type: 'screenshot', url: item } : item;

// // // //               return (
// // // //                 <SwiperSlide key={index} className="hero-slide">
// // // //                   <div className="w-full flex items-center justify-center py-2 md:py-4">
// // // //                     {imageData.type === 'phone' && imageData.screenshot ? (
// // // //                       // Phone with screenshot inside - RESPONSIVE
// // // //                       <div className="relative w-full max-w-[150px] sm:max-w-[240px] md:max-w-[280px] lg:max-w-xs mx-auto">
// // // //                         {/* Screenshot layer - behind */}
// // // //                         <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[1.5rem] sm:rounded-[2rem] md:rounded-[2.5rem] z-0">
// // // //                           <img 
// // // //                             src={imageData.screenshot} 
// // // //                             alt="Screenshot" 
// // // //                             className="w-full h-full object-cover object-top" 
// // // //                           />
// // // //                         </div>
// // // //                         {/* Phone mockup layer - front */}
// // // //                         <img 
// // // //                           src={PHONE_MOCKUP} 
// // // //                           alt="Phone" 
// // // //                           className="relative w-full h-auto drop-shadow-2xl z-10" 
// // // //                         />
// // // //                       </div>
// // // //                     ) : imageData.type === 'person' ? (
// // // //                       // Person image - RESPONSIVE
// // // //                       <img 
// // // //                         src={imageData.url} 
// // // //                         alt="Team" 
// // // //                         className="w-full h-auto max-h-[300px] sm:max-h-[400px] md:max-h-[500px] lg:max-h-[600px] rounded-2xl md:rounded-3xl shadow-2xl object-cover"
// // // //                       />
// // // //                     ) : (
// // // //                       // Screenshot or other image - RESPONSIVE
// // // //                       <img 
// // // //                         src={imageData.url} 
// // // //                         alt="Screenshot" 
// // // //                         className="w-full h-auto max-h-[300px] sm:max-h-[400px] md:max-h-[500px] lg:max-h-[600px] rounded-2xl md:rounded-3xl "
// // // //                       />
// // // //                     )}
// // // //                   </div>
// // // //                 </SwiperSlide>
// // // //               );
// // // //             })}
// // // //           </Swiper>
// // // //         </div>
// // // //       </div>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default Hero;

// // // import React, { useState, useEffect } from 'react';
// // // import { Button } from '@/components/ui/button'; // DIUBAH: Path disesuaikan
// // // import { ArrowRight } from 'lucide-react';
// // // import axios from 'axios';
// // // import { Swiper, SwiperSlide } from 'swiper/react';
// // // import { EffectCoverflow, Pagination, Autoplay, Navigation } from 'swiper/modules';
// // // import 'swiper/css';
// // // import 'swiper/css/effect-coverflow';
// // // import 'swiper/css/pagination';
// // // import 'swiper/css/navigation';


// // // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000' || 'http://localhost:8000';
// // // const PHONE_MOCKUP = "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png";

// // // const Hero = () => {
// // //   const [heroData, setHeroData] = useState(null);

// // //   useEffect(() => {
// // //     fetchHeroData();
// // //   }, []);

// // //   const fetchHeroData = async () => {
// // //     try {
// // //       const response = await axios.get(`${BACKEND_URL}/api/public/hero`);
// // //       setHeroData(response.data);
// // //     } catch (error) {
// // //       console.error('Failed to fetch hero data:', error);
// // //       // Fallback to mock data with mixed content
// // //       setHeroData({
// // //         badge: "New",
// // //         badge_text: "Welcome to TokoSprint",
// // //         title: "Build & grow your online store effortlessly",
// // //         subtitle: "Everything you need to launch your store in minutes.",
// // //         cta_text: "Get Started",
// // //         images: [
// // //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif" },
// // //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b10f6fc0682fbb04ccd8_Screenshot%202025-11-03%20222734.png" },
// // //           { type: "phone", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png", screenshot: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b0f2df576aa7a8d2d64e_Screenshot%202025-11-04%20101504.png" },
// // //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b1513050004f070d6d76_Screenshot%202025-11-04%20145444.png" },
// // //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif" }
// // //         ]
// // //       });
// // //     }
// // //   };

// // //   if (!heroData) {
// // //     return <div className="h-screen flex items-center justify-center">Loading...</div>;
// // //   }

// // //   const showControls = heroData.images.length > 5;

// // //   return (
// // //     // DIUBAH: Dihapus 'bg-gradient-blue-strong bg-tech-dots'
// // //     <section id="hero" className="relative pt-20 md:pt-32 pb-64 md:pb-20 px-4 md:px-6 overflow-visible">
// // //       <div className="max-w-7xl mx-auto">
// // //         {/* Badge */}
// // //         <div className="flex justify-center mb-6 md:mb-8 animate-in fade-in slide-in-from-top duration-700">
// // //           <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-brand-blue-500 to-brand-blue-600 text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-xs md:text-sm font-medium shadow-lg">
// // //             <span className="bg-white/20 px-2 md:px-3 py-0.5 md:py-1 rounded-full text-xs font-semibold">{heroData.badge}</span>
// // //             <span className="text-xs md:text-sm">{heroData.badge_text}</span>
// // //           </div>
// // //         </div>

// // //         {/* Main Title */}
// // //         <div className="text-center max-w-5xl mx-auto mb-8 md:mb-12 animate-in fade-in slide-in-from-bottom duration-700">
// // //           {/* DIUBAH: Teks judul diubah menjadi 'text-white' (via 'text-foreground' dari dark mode) */}
// // //           <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-8 leading-tight tracking-tight px-2 text-white">
// // //             {heroData.title}
// // //           </h1>
// // //           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
// // //           <p className="text-base md:text-xl lg:text-2xl text-gray-300 mb-6 md:mb-10 max-w-2xl mx-auto px-4">
// // //             {heroData.subtitle}
// // //           </p>
// // //           {/* Tombol ini (putih) sudah kontras dengan background gelap, jadi tidak diubah */}
// // //           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-200 hover:border-gray-400 rounded-xl px-6 md:px-10 py-5 md:py-7 text-base md:text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
// // //             {heroData.cta_text}
// // //             <ArrowRight className="w-4 h-4 md:w-5 md:h-5 ml-2" />
// // //           </Button>
// // //         </div>

// // //         {/* Swiper Carousel with Coverflow Effect */}
// // //         <div className="relative mt-12 md:mt-24 w-full">
// // //           <Swiper
// // //             effect={'coverflow'}
// // //             grabCursor={true}
// // //             centeredSlides={true}
// // //             loop={false}
// // //             slidesPerView={'1'}
// // //             centerInsufficientSlides={true}
// // //             coverflowEffect={{
// // //               rotate: 0,
// // //               stretch: 35,
// // //               depth: 150,
// // //               modifier: 1.5,
// // //               slideShadows: false,
// // //             }}
// // //             autoplay={{
// // //               delay: 2500,
// // //               disableOnInteraction: false,
// // //             }}
// // //             pagination={{
// // //               clickable: true,
// // //               dynamicBullets: true,
// // //             }}
// // //             navigation={true}
// // //             modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
// // //             className="hero-swiper"
// // //             breakpoints={{
// // //               320: {
// // //                 slidesPerView: 1,
// // //                 spaceBetween: 10,
// // //                 coverflowEffect: {
// // //                   depth: 100,
// // //                   modifier: 1,
// // //                   stretch: 10,
// // //                 },
// // //               },
// // //               640: {
// // //                 slidesPerView: 1.5,
// // //                 spaceBetween: 10,
// // //                 coverflowEffect: {
// // //                   depth: 120,
// // //                   modifier: 1.1,
// // //                   stretch: -10,
// // //                 },
// // //               },
// // //               768: {
// // //                 slidesPerView: 2,
// // //                 spaceBetween: 20,
// // //                 coverflowEffect: {
// // //                   depth: 150,
// // //                   modifier: 1.2,
// // //                   stretch: 35,
// // //                 },
// // //               },
// // //               1024: {
// // //                 slidesPerView: 3,
// // //                 spaceBetween: 30,
// // //                 coverflowEffect: {
// // //                   depth: 150,
// // //                   modifier: 1.5,
// // //                   stretch: 35,
// // //                 },
// // //               },
// // //             }}
// // //           >
// // //             {heroData.images.map((item, index) => {
// // //               // Handle string format (old data) - convert to object
// // //               const imageData = typeof item === 'string' ? { type: 'screenshot', url: item } : item;

// // //               return (
// // //                 <SwiperSlide key={index} className="hero-slide">
// // //                   <div className="w-full flex items-center justify-center py-2 md:py-4">
// // //                     {imageData.type === 'phone' && imageData.screenshot ? (
// // //                       // Phone with screenshot inside - RESPONSIVE
// // //                       <div className="relative w-full max-w-[150px] sm:max-w-[240px] md:max-w-[280px] lg:max-w-xs mx-auto">
// // //                         {/* Screenshot layer - behind */}
// // //                         <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[1.5rem] sm:rounded-[2rem] md:rounded-[2.5rem] z-0">
// // //                           <img 
// // //                             src={imageData.screenshot} 
// // //                             alt="Screenshot" 
// // //                             className="w-full h-full object-cover object-top" 
// // //                           />
// // //                         </div>
// // //                         {/* Phone mockup layer - front */}
// // //                         <img 
// // //                           src={PHONE_MOCKUP} 
// // //                           alt="Phone" 
// // //                           className="relative w-full h-auto drop-shadow-2xl z-10" 
// // //                         />
// // //                       </div>
// // //                     ) : imageData.type === 'person' ? (
// // //                       // Person image - RESPONSIVE
// // //                       <img 
// // //                         src={imageData.url} 
// // //                         alt="Team" 
// // //                         className="w-full h-auto max-h-[300px] sm:max-h-[400px] md:max-h-[500px] lg:max-h-[600px] rounded-2xl md:rounded-3xl shadow-2xl object-cover"
// // //                       />
// // //                     ) : (
// // //                       // Screenshot or other image - RESPONSIVE
// // //                       <img 
// // //                         src={imageData.url} 
// // //                         alt="Screenshot" 
// // //                         className="w-full h-auto max-h-[300px] sm:max-h-[400px] md:max-h-[500px] lg:max-h-[600px] rounded-2xl md:rounded-3xl "
// // //                       />
// // //                     )}
// // //                   </div>
// // //                 </SwiperSlide>
// // //               );
// // //             })}
// // //           </Swiper>
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default Hero;

// // import React, { useState, useEffect } from 'react';
// // import { Button } from '@/components/ui/button'; // DIUBAH: Path disesuaikan
// // import { ArrowRight } from 'lucide-react';
// // import axios from 'axios';
// // import { Swiper, SwiperSlide } from 'swiper/react';
// // import { EffectCoverflow, Pagination, Autoplay, Navigation } from 'swiper/modules';
// // import 'swiper/css';
// // import 'swiper/css/effect-coverflow';
// // import 'swiper/css/pagination';
// // import 'swiper/css/navigation';


// // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000' || 'http://localhost:8000';
// // const PHONE_MOCKUP = "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png";

// // const Hero = () => {
// //   const [heroData, setHeroData] = useState(null);

// //   useEffect(() => {
// //     fetchHeroData();
// //   }, []);

// //   const fetchHeroData = async () => {
// //     try {
// //       const response = await axios.get(`${BACKEND_URL}/api/public/hero`);
// //       setHeroData(response.data);
// //     } catch (error) {
// //       console.error('Failed to fetch hero data:', error);
// //       // Fallback to mock data with mixed content
// //       setHeroData({
// //         badge: "New",
// //         badge_text: "Welcome to TokoSprint",
// //         title: "Build & grow your online store effortlessly",
// //         subtitle: "Everything you need to launch your store in minutes.",
// //         cta_text: "Get Started",
// //         images: [
// //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif" },
// //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b10f6fc0682fbb04ccd8_Screenshot%202025-11-03%20222734.png" },
// //           { type: "phone", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png", screenshot: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b0f2df576aa7a8d2d64e_Screenshot%202025-11-04%20101504.png" },
// //           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b1513050004f070d6d76_Screenshot%202025-11-04%20145444.png" },
// //           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif" }
// //         ]
// //       });
// //     }
// //   };

// //   if (!heroData) {
// //     return <div className="h-screen flex items-center justify-center">Loading...</div>;
// //   }

// //   const showControls = heroData.images.length > 5;

// //   return (
// //     // DIUBAH: Dihapus 'bg-gradient-blue-strong bg-tech-dots'
// //     <section id="hero" className="relative pt-20 md:pt-32 pb-64 md:pb-20 px-4 md:px-6 overflow-visible">
// //       <div className="max-w-7xl mx-auto">
// //         {/* Badge */}
// //         <div className="flex justify-center mb-6 md:mb-8 animate-in fade-in slide-in-from-top duration-700">
// //           <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-brand-blue-500 to-brand-blue-600 text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-xs md:text-sm font-medium shadow-lg">
// //             <span className="bg-white/20 px-2 md:px-3 py-0.5 md:py-1 rounded-full text-xs font-semibold">{heroData.badge}</span>
// //             <span className="text-xs md:text-sm">{heroData.badge_text}</span>
// //           </div>
// //         </div>

// //         {/* Main Title */}
// //         <div className="text-center max-w-5xl mx-auto mb-8 md:mb-12 animate-in fade-in slide-in-from-bottom duration-700">
// //           {/* DIUBAH: Teks judul diubah menjadi 'text-white' (via 'text-foreground' dari dark mode) */}
// //           <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-8 leading-tight tracking-tight px-2 text-white">
// //             {heroData.title}
// //           </h1>
// //           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
// //           <p className="text-base md:text-xl lg:text-2xl text-gray-300 mb-6 md:mb-10 max-w-2xl mx-auto px-4">
// //             {heroData.subtitle}
// //           </p>
// //           {/* Tombol ini (putih) sudah kontras dengan background gelap, jadi tidak diubah */}
// //           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-200 hover:border-gray-400 rounded-xl px-6 md:px-10 py-5 md:py-7 text-base md:text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
// //             {heroData.cta_text}
// //             <ArrowRight className="w-4 h-4 md:w-5 md:h-5 ml-2" />
// //           </Button>
// //         </div>

// //         {/* Swiper Carousel with Coverflow Effect */}
// //         <div className="relative mt-12 md:mt-24 w-full">
// //           <Swiper
// //             effect={'coverflow'}
// //             grabCursor={true}
// //             centeredSlides={true}
// //             loop={false}
// //             slidesPerView={'1'}
// //             centerInsufficientSlides={true}
// //             coverflowEffect={{
// //               rotate: 0,
// //               stretch: 35,
// //               depth: 150,
// //               modifier: 1.5,
// //               slideShadows: false,
// //             }}
// //             autoplay={{
// //               delay: 2500,
// //               disableOnInteraction: false,
// //             }}
// //             pagination={{
// //               clickable: true,
// //               dynamicBullets: true,
// //             }}
// //             navigation={true}
// //             modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
// //             className="hero-swiper"
// //             breakpoints={{
// //               320: {
// //                 slidesPerView: 1,
// //                 spaceBetween: 10,
// //                 coverflowEffect: {
// //                   depth: 100,
// //                   modifier: 1,
// //                   stretch: 10,
// //                 },
// //               },
// //               640: {
// //                 slidesPerView: 1.5,
// //                 spaceBetween: 10,
// //                 coverflowEffect: {
// //                   depth: 120,
// //                   modifier: 1.1,
// //                   stretch: -10,
// //                 },
// //               },
// //               768: {
// //                 slidesPerView: 2,
// //                 spaceBetween: 20,
// //                 coverflowEffect: {
// //                   depth: 150,
// //                   modifier: 1.2,
// //                   stretch: 35,
// //                 },
// //               },
// //               1024: {
// //                 slidesPerView: 3,
// //                 spaceBetween: 30,
// //                 coverflowEffect: {
// //                   depth: 150,
// //                   modifier: 1.5,
// //                   stretch: 35,
// //                 },
// //               },
// //             }}
// //           >
// //             {heroData.images.map((item, index) => {
// //               // Handle string format (old data) - convert to object
// //               const imageData = typeof item === 'string' ? { type: 'screenshot', url: item } : item;

// //               return (
// //                 <SwiperSlide key={index} className="hero-slide">
// //                   <div className="w-full flex items-center justify-center py-2 md:py-4">
// //                     {imageData.type === 'phone' && imageData.screenshot ? (
// //                       // Phone with screenshot inside - RESPONSIVE
// //                       <div className="relative w-full max-w-[150px] sm:max-w-[240px] md:max-w-[280px] lg:max-w-xs mx-auto">
// //                         {/* Screenshot layer - behind */}
// //                         <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[1.5rem] sm:rounded-[2rem] md:rounded-[2.5rem] z-0">
// //                           <img 
// //                             src={imageData.screenshot} 
// //                             alt="Screenshot" 
// //                             className="w-full h-full object-cover object-top" 
// //                           />
// //                         </div>
// //                         {/* Phone mockup layer - front */}
// //                         <img 
// //                           src={PHONE_MOCKUP} 
// //                           alt="Phone" 
// //                           className="relative w-full h-auto drop-shadow-2xl z-10" 
// //                         />
// //                       </div>
// //                     ) : imageData.type === 'person' ? (
// //                       // Person image - RESPONSIVE
// //                       <img 
// //                         src={imageData.url} 
// //                         alt="Team" 
// //                         // DIUBAH: max-h disesuaikan agar konsisten & object-contain
// //                         className="w-full h-auto max-h-[310px] sm:max-h-[490px] md:max-h-[570px] lg:max-h-[650px] rounded-2xl md:rounded-3xl shadow-2xl object-contain"
// //                       />
// //                     ) : (
// //                       // Screenshot or other image - RESPONSIVE
// //                       <img 
// //                         src={imageData.url} 
// //                         alt="Screenshot" 
// //                         // DIUBAH: max-h disesuaikan agar konsisten & object-contain
// //                         className="w-full h-auto max-h-[310px] sm:max-h-[490px] md:max-h-[570px] lg:max-h-[650px] rounded-2xl md:rounded-3xl object-contain"
// //                       />
// //                     )}
// //                   </div>
// //                 </SwiperSlide>
// //               );
// //             })}
// //           </Swiper>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Hero;


// //FIXX Belum TEXT TYPE
// import React, { useState, useEffect } from 'react';
// import { Button } from '@/components/ui/button'; // DIUBAH: Path disesuaikan
// import { ArrowRight } from 'lucide-react';
// import axios from 'axios';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { EffectCoverflow, Pagination, Autoplay, Navigation } from 'swiper/modules';
// import RotatingText from '@/components/RotatingText'; // DIITAMBAHKAN
// import 'swiper/css';
// import 'swiper/css/effect-coverflow';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';


// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000' || 'http://localhost:8000';
// const PHONE_MOCKUP = "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png";

// const Hero = () => {
//   const [heroData, setHeroData] = useState(null);

//   useEffect(() => {
//     fetchHeroData();
//   }, []);

//   const fetchHeroData = async () => {
//     try {
//       const response = await axios.get(`${BACKEND_URL}/api/public/hero`);
//       setHeroData(response.data);
//     } catch (error) {
//       console.error('Failed to fetch hero data:', error);
//       // Fallback to mock data with mixed content
//       setHeroData({
//         badge: "New",
//         badge_text: "Welcome to TokoSprint",
//         title: "Build & grow your online store effortlessly",
//         subtitle: "Everything you need to launch your store in minutes.",
//         cta_text: "Get Started",
//         images: [
//           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif" },
//           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b10f6fc0682fbb04ccd8_Screenshot%202025-11-03%20222734.png" },
//           { type: "phone", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png", screenshot: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b0f2df576aa7a8d2d64e_Screenshot%202025-11-04%20101504.png" },
//           { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b1513050004f070d6d76_Screenshot%202025-11-04%20145444.png" },
//           { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif" }
//         ]
//       });
//     }
//   };

//   if (!heroData) {
//     return <div className="h-screen flex items-center justify-center">Loading...</div>;
//   }

//   // DIUBAH: Array ini sekarang HANYA untuk teks yang berputar
//   const rotatingTexts = [
//     heroData.badge, // e.g., "New"
//     "Mulai Toko Anda",
//     "Coba Gratis",
//     "Fitur Terbaru!"
//   ];

//   const showControls = heroData.images.length > 5;

//   return (
//     // DIUBAH: Dihapus 'bg-gradient-blue-strong bg-tech-dots'
//     <section id="hero" className="relative pt-20 md:pt-32 pb-64 md:pb-20 px-4 md:px-6 overflow-visible">
//       <div className="max-w-7xl mx-auto">
//         {/* Badge */}
//         {/* DIUBAH: Struktur badge diubah total untuk memisahkan teks statis dan dinamis */}
//         <div className="flex justify-center items-center space-x-2 mb-6 md:mb-8 animate-in fade-in slide-in-from-top duration-700">
          
//           {/* Teks Statis (seperti "Creative" di contoh Anda) */}
//           <span className="text-white text-base md:text-lg font-medium">
//             {heroData.badge_text}
//           </span>

//           {/* Teks Bergerak (seperti "coding" di contoh Anda) */}
//           <RotatingText
//             texts={rotatingTexts} // Menggunakan array baru
//             // DIUBAH: mainClassName sekarang menjadi kotak dinamis
//             mainClassName="bg-gradient-to-r from-brand-blue-500 to-brand-blue-600 text-white px-3 py-0.5 md:py-1 rounded-md text-base md:text-lg font-medium shadow-lg overflow-hidden justify-center"
//             splitLevelClassName="overflow-hidden" // style untuk "coding"
//             staggerFrom={"last"}
//             initial={{ y: "100%" }}
//             animate={{ y: 0 }}
//             exit={{ y: "-120%" }}
//             staggerDuration={0.025}
//             transition={{ type: "spring", damping: 30, stiffness: 400 }}
//             rotationInterval={2000}
//           />
//         </div>

//         {/* Main Title */}
//         <div className="text-center max-w-5xl mx-auto mb-8 md:mb-12 animate-in fade-in slide-in-from-bottom duration-700">
//           {/* DIUBAH: Teks judul diubah menjadi 'text-white' (via 'text-foreground' dari dark mode) */}
//           <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-8 leading-tight tracking-tight px-2 text-white">
//             {heroData.title}
//           </h1>
//           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
//           <p className="text-base md:text-xl lg:text-2xl text-gray-300 mb-6 md:mb-10 max-w-2xl mx-auto px-4">
//             {heroData.subtitle}
//           </p>
//           {/* Tombol ini (putih) sudah kontras dengan background gelap, jadi tidak diubah */}
//           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-200 hover:border-gray-400 rounded-xl px-6 md:px-10 py-5 md:py-7 text-base md:text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
//             {heroData.cta_text}
//             <ArrowRight className="w-4 h-4 md:w-5 md:h-5 ml-2" />
//           </Button>
//         </div>

//         {/* Swiper Carousel with Coverflow Effect */}
//         <div className="relative mt-12 md:mt-24 w-full">
//           <Swiper
//             effect={'coverflow'}
//             grabCursor={true}
//             centeredSlides={true}
//             loop={false}
//             slidesPerView={'1'}
//             centerInsufficientSlides={true}
//             coverflowEffect={{
//               rotate: 0,
//               stretch: 35,
//               depth: 150,
//               modifier: 1.5,
//               slideShadows: false,
//             }}
//             autoplay={{
//               delay: 2500,
//               disableOnInteraction: false,
//             }}
//             pagination={{
//               clickable: true,
//               dynamicBullets: true,
//             }}
//             navigation={true}
//             modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
//             className="hero-swiper"
//             breakpoints={{
//               320: {
//                 slidesPerView: 1,
//                 spaceBetween: 10,
//                 coverflowEffect: {
//                   depth: 100,
//                   modifier: 1,
//                   stretch: 10,
//                 },
//               },
//               640: {
//                 slidesPerView: 1.5,
//                 spaceBetween: 10,
//                 coverflowEffect: {
//                   depth: 120,
//                   modifier: 1.1,
//                   stretch: -10,
//                 },
//               },
//               768: {
//                 slidesPerView: 2,
//                 spaceBetween: 20,
//                 coverflowEffect: {
//                   depth: 150,
//                   modifier: 1.2,
//                   stretch: 35,
//                 },
//               },
//               1024: {
//                 slidesPerView: 3,
//                 spaceBetween: 30,
//                 coverflowEffect: {
//                   depth: 150,
//                   modifier: 1.5,
//                   stretch: 35,
//                 },
//               },
//             }}
//           >
//             {heroData.images.map((item, index) => {
//               // Handle string format (old data) - convert to object
//               const imageData = typeof item === 'string' ? { type: 'screenshot', url: item } : item;

//               return (
//                 <SwiperSlide key={index} className="hero-slide">
//                   <div className="w-full flex items-center justify-center py-2 md:py-4">
//                     {imageData.type === 'phone' && imageData.screenshot ? (
//                       // Phone with screenshot inside - RESPONSIVE
//                       <div className="relative w-full max-w-[150px] sm:max-w-[240px] md:max-w-[280px] lg:max-w-xs mx-auto">
//                         {/* Screenshot layer - behind */}
//                         <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[1.5rem] sm:rounded-[2rem] md:rounded-[2.5rem] z-0">
//                           <img 
//                             src={imageData.screenshot} 
//                             alt="Screenshot" 
//                             className="w-full h-full object-cover object-top" 
//                           />
//                         </div>
//                         {/* Phone mockup layer - front */}
//                         <img 
//                           src={PHONE_MOCKUP} 
//                           alt="Phone" 
//                           className="relative w-full h-auto drop-shadow-2xl z-10" 
//                         />
//                       </div>
//                     ) : imageData.type === 'person' ? (
//                       // Person image - RESPONSIVE
//                       <img 
//                         src={imageData.url} 
//                         alt="Team" 
//                         // DIUBAH: max-h disesuaikan agar konsisten & object-contain
//                         className="w-full h-auto max-h-[310px] sm:max-h-[490px] md:max-h-[570px] lg:max-h-[650px] rounded-2xl md:rounded-3xl shadow-2xl object-contain"
//                       />
//                     ) : (
//                       // Screenshot or other image - RESPONSIVE
//                       <img 
//                         src={imageData.url} 
//                         alt="Screenshot" 
//                         // DIUBAH: max-h disesuaikan agar konsisten & object-contain
//                         className="w-full h-auto max-h-[310px] sm:max-h-[490px] md:max-h-[570px] lg:max-h-[650px] rounded-2xl md:rounded-3xl object-contain"
//                       />
//                     )}
//                   </div>
//                 </SwiperSlide>
//               );
//             })}
//           </Swiper>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;

import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button'; // DIUBAH: Path disesuaikan
import { ArrowRight } from 'lucide-react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Autoplay, Navigation } from 'swiper/modules';
import RotatingText from '@/components/RotatingText'; // DIITAMBAHKAN
import TextType from '@/components/TextType'; // DIITAMBAHKAN
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '@/components/TextType.css'; // DIITAMBAHKAN


const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000' || 'http://localhost:8000';
const PHONE_MOCKUP = "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png";

const Hero = () => {
  const [heroData, setHeroData] = useState(null);

  useEffect(() => {
    fetchHeroData();
  }, []);

  const fetchHeroData = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/public/hero`);
      setHeroData(response.data);
    } catch (error) {
      console.error('Failed to fetch hero data:', error);
      // Fallback to mock data with mixed content
      setHeroData({
        badge: "New",
        badge_text: "Welcome to TokoSprint",
        title: "Build & grow your online store effortlessly",
        subtitle: "Everything you need to launch your store in minutes.",
        cta_text: "Get Started",
        images: [
          { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eaf_Team%20Image.avif" },
          { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b10f6fc0682fbb04ccd8_Screenshot%202025-11-03%20222734.png" },
          { type: "phone", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b053ac74f308f11f2df6_iPhone%2014%20Pro.png", screenshot: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b0f2df576aa7a8d2d64e_Screenshot%202025-11-04%20101504.png" },
          { type: "screenshot", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b1513050004f070d6d76_Screenshot%202025-11-04%20145444.png" },
          { type: "person", url: "https://cdn.prod.website-files.com/6909add2e2d94f386f984495/6909b054ac74f308f11f2eb8_Team%20Person%20Image%206.avif" }
        ]
      });
    }
  };

  if (!heroData) {
    return <div className="h-screen flex items-center justify-center">Loading...</div>;
  }

  // DIUBAH: Array ini sekarang HANYA untuk teks yang berputar
  const rotatingTexts = [
    heroData.badge, // e.g., "New"
    "Start Your Store",
    "Free Trial",
    "New Features!",
    "Launch Today",
    "All-in-One Platform"
  ];

  // DIITAMBAHKAN: Array untuk judul hero yang beranimasi
  const heroTitles = [
    heroData.title, // "Build & grow your online store effortlessly"
    "Launch your store today",
    "All in one platform !"
  ];

  const showControls = heroData.images.length > 5;

  return (
    // DIUBAH: Dihapus 'bg-gradient-blue-strong bg-tech-dots'
    <section id="hero" className="relative pt-20 md:pt-32 pb-64 md:pb-20 px-4 md:px-6 overflow-visible">
      <div className="max-w-7xl mx-auto">
        {/* Badge */}
        {/* DIUBAH: Struktur badge diubah total untuk memisahkan teks statis dan dinamis */}
        <div className="flex justify-center items-center space-x-2 mb-6 md:mb-8 animate-in fade-in slide-in-from-top duration-700">
          
          {/* Teks Statis (seperti "Creative" di contoh Anda) */}
          {/* PERUBAHAN UKURAN FONT:
            Ubah 'text-xs md:text-sm' menjadi 'text-base md:text-lg' (atau ukuran lain)
          */}
          <span className="text-white text-base md:text-lg font-medium">
            {heroData.badge_text}
          </span>

          {/* Teks Bergerak (seperti "coding" di contoh Anda) */}
          <RotatingText
            texts={rotatingTexts} // Menggunakan array baru
            /*
              PERUBAHAN WARNA & UKURAN:
              Semua ada di 'mainClassName'.
              1.  WARNA KOTAK: Ubah 'from-brand-blue-500 to-brand-blue-600'
                  menjadi warna yang Anda inginkan (contoh: 'from-pink-500 to-purple-600').
              2.  UKURAN FONT: Ubah 'text-xs md:text-sm' menjadi 'text-base md:text-lg'.
            */
            mainClassName="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-3 py-0.5 md:py-1 rounded-md text-base md:text-lg font-medium shadow-lg overflow-hidden justify-center"
            splitLevelClassName="overflow-hidden" // style untuk "coding"
            staggerFrom={"last"}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-120%" }}
            staggerDuration={0.025}
            transition={{ type: "spring", damping: 30, stiffness: 400 }}
            rotationInterval={2000}
          />
        </div>

        {/* Main Title */}
        <div className="text-center max-w-5xl mx-auto mb-8 md:mb-12 animate-in fade-in slide-in-from-bottom duration-700">
          {/* DIUBAH: <h1> statis diganti dengan <TextType> */}
          <TextType
            as="h1" // Menggunakan 'h1' secara semantik
            text={heroTitles} // Menggunakan array yang baru dibuat
            // Menggunakan styling yang SAMA PERSIS dengan h1 sebelumnya
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-8 leading-tight tracking-tight px-2 text-white"
            typingSpeed={100}
            pauseDuration={1000}
            showCursor={true}
            cursorCharacter="_"
          />
          
          {/* DIHAPUS: <h1> yang lama
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-8 leading-tight tracking-tight px-2 text-white">
            {heroData.title}
          </h1>
          */}

          {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
          <p className="text-base md:text-xl lg:text-2xl text-gray-300 mb-6 md:mb-10 max-w-2xl mx-auto px-4">
            {heroData.subtitle}
          </p>
          {/* Tombol ini (putih) sudah kontras dengan background gelap, jadi tidak diubah */}
          <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-200 hover:border-gray-400 rounded-xl px-6 md:px-10 py-5 md:py-7 text-base md:text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
            {heroData.cta_text}
            <ArrowRight className="w-4 h-4 md:w-5 md:h-5 ml-2" />
          </Button>
        </div>

        {/* Swiper Carousel with Coverflow Effect */}
        <div className="relative mt-12 md:mt-24 w-full">
          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            loop={false}
            slidesPerView={'1'}
            centerInsufficientSlides={true}
            coverflowEffect={{
              rotate: 0,
              stretch: 35,
              depth: 150,
              modifier: 1.5,
              slideShadows: false,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            navigation={true}
            modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
            className="hero-swiper"
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
                coverflowEffect: {
                  depth: 100,
                  modifier: 1,
                  stretch: 10,
                },
              },
              640: {
                slidesPerView: 1.5,
                spaceBetween: 10,
                coverflowEffect: {
                  depth: 120,
                  modifier: 1.1,
                  stretch: -10,
                },
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
                coverflowEffect: {
                  depth: 150,
                  modifier: 1.2,
                  stretch: 35,
                },
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
                coverflowEffect: {
                  depth: 150,
                  modifier: 1.5,
                  stretch: 35,
                },
              },
            }}
          >
            {heroData.images.map((item, index) => {
              // Handle string format (old data) - convert to object
              const imageData = typeof item === 'string' ? { type: 'screenshot', url: item } : item;

              return (
                <SwiperSlide key={index} className="hero-slide">
                  <div className="w-full flex items-center justify-center py-2 md:py-4">
                    {imageData.type === 'phone' && imageData.screenshot ? (
                      // Phone with screenshot inside - RESPONSIVE
                      <div className="relative w-full max-w-[150px] sm:max-w-[240px] md:max-w-[280px] lg:max-w-xs mx-auto">
                        {/* Screenshot layer - behind */}
                        <div className="absolute top-[3%] left-[8%] w-[84%] h-[90%] overflow-hidden rounded-[1.5rem] sm:rounded-[2rem] md:rounded-[2.5rem] z-0">
                          <img 
                            src={imageData.screenshot} 
                            alt="Screenshot" 
                            className="w-full h-full object-cover object-top" 
                          />
                        </div>
                        {/* Phone mockup layer - front */}
                        <img 
                          src={PHONE_MOCKUP} 
                          alt="Phone" 
                          className="relative w-full h-auto drop-shadow-2xl z-10" 
                        />
                      </div>
                    ) : imageData.type === 'person' ? (
                      // Person image - RESPONSIVE
                      <img 
                        src={imageData.url} 
                        alt="Team" 
                        // DIUBAH: max-h disesuaikan agar konsisten & object-contain
                        className="w-full h-auto max-h-[310px] sm:max-h-[490px] md:max-h-[570px] lg:max-h-[650px] rounded-2xl md:rounded-3xl shadow-2xl object-contain"
                      />
                    ) : (
                      // Screenshot or other image - RESPONSIVE
                      <img 
                        src={imageData.url} 
                        alt="Screenshot" 
                        // DIUBAH: max-h disesuaikan agar konsisten & object-contain
                        className="w-full h-auto max-h-[310px] sm:max-h-[490px] md:max-h-[570px] lg:max-h-[650px] rounded-2xl md:rounded-3xl object-contain"
                      />
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Hero;